function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React, { useState } from 'react';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
const RangePicker = DatePicker.RangePicker;
const MIN_YEAR = 2021;
const MAX_YEAR = dayjs().year();
export default function MonthFilter({ onChange }) {
    const _useState = useState('thisMonth'), _useState2 = _slicedToArray(_useState, 2), monthMode = _useState2[0], setMonthMode = _useState2[1];
    const _useState3 = useState([dayjs().startOf('month'), dayjs().endOf('month')]), _useState4 = _slicedToArray(_useState3, 2), range = _useState4[0], setRange = _useState4[1];
    const handleRangeChange = dates => {
        if (dates && dates[0] && dates[1]) {
            setRange([dayjs(dates[0].toISOString()), dayjs(dates[1].toISOString())]);
            setMonthMode('custom');
            onChangeDate(dayjs(dates[0].toISOString()), dayjs(dates[1].toISOString()));
        }
    };
    function onChangeDate(start, end) {
        const startDate = start.format('YYYY-MM-DD');
        const endDate = end.format('YYYY-MM-DD');
        onChange === null || onChange === void 0 ? void 0 : onChange(startDate, endDate);
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "flex "
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center gap-4 text-xl"
    }, /*#__PURE__*/ React.createElement("span", {
        className: `cursor-pointer ${monthMode === 'thisMonth' ? 'text-yellow-500 font-semibold' : 'text-gray-800'}`,
        onClick: () => {
            setMonthMode('thisMonth');
            const start = dayjs().startOf('month');
            const end = dayjs().endOf('month');
            setRange([start, end]);
            onChangeDate(start, end);
        }
    }, "\u4ECA\u6708"), /*#__PURE__*/ React.createElement("span", {
        className: `cursor-pointer ${monthMode === 'lastMonth' ? 'text-yellow-500 font-semibold' : 'text-gray-800'}`,
        onClick: () => {
            setMonthMode('lastMonth');
            const start = dayjs().subtract(1, 'month').startOf('month');
            const end = dayjs().subtract(1, 'month').endOf('month');
            setRange([start, end]);
            onChangeDate(start, end);
        }
    }, "\u524D\u6708"), /*#__PURE__*/ React.createElement("span", {
        className: `cursor-pointer ${monthMode === 'custom' ? 'text-yellow-500 font-semibold' : 'text-gray-800'}`,
        onClick: () => setMonthMode('custom')
    }, "\u671F\u9593\u6307\u5B9A")), /*#__PURE__*/ React.createElement(RangePicker, {
        className: "ml-2",
        value: range,
        onChange: handleRangeChange,
        allowClear: false,
        inputReadOnly: true,
        format: "YYYY-MM-DD",
        classNames: {
            popup: {
                root: 'z-50'
            }
        },
        disabled: monthMode !== 'custom' // 👈 disable when not "期間指定"
        ,
        disabledDate: current => {
            if (!current)
                return false;
            const y = current.year();
            return y < MIN_YEAR || y > MAX_YEAR;
        }
    }));
}
